import React from 'react';
import { HoverPopup, PresenceHoverCard } from '..';

interface GeoHoverCardProps {
    isCatchmentOn: boolean;
    hoverData: any;
    outOfBounds: string[];
    isGeoFocused: boolean;
    companyName: string;
    focusedPoi?: any;
    mbpRoi: { north: number; south: number; east: number; west: number; } | null;
    onCloseRegion: () => void;
    onCloseCatchment: (e: any) => void;
    onNavigate: (e: any, resetFields: any, navigation: any, geoLevel: string) => void;
    onNavigateFromRegion: (e: any, navigation: any) => void;
    carousel?: {
        features: any[];
        currentIndex: number;
    } | null;
    onCarouselNext?: () => void;
    onCarouselPrev?: () => void;
}

/**
 * GeoHoverCard - Displays hover card for geographic regions
 * Supports both regular geo regions and catchment areas
 */
export const GeoHoverCard: React.FC<GeoHoverCardProps> = ({
    isCatchmentOn,
    hoverData,
    outOfBounds,
    isGeoFocused,
    companyName,
    focusedPoi,
    mbpRoi,
    onCloseRegion,
    onCloseCatchment,
    onNavigate,
    onNavigateFromRegion,
    carousel,
    onCarouselNext,
    onCarouselPrev,
}) => {
    if (!hoverData) return null;


    return (
        <div
            className={`deck-map-prop-hover-card position-absolute pe-none z-index-200 ${outOfBounds.join(' ')}`}
            style={{
                left: `${hoverData.x}px`,
                top: `${hoverData.y}px`,
            }}
        >
            {hoverData.geoLevel === 'catchment' ? (
                <PresenceHoverCard
                    classname={isCatchmentOn ? 'deck-hover-popup' : 'presence-hover-popup'}
                    presence={hoverData}
                    company_name={companyName}
                    focusedPoi={focusedPoi}
                    handleClose={onCloseCatchment}
                    handleNavigation={onNavigate}
                    roi={mbpRoi}
                />
            ) : (
                <HoverPopup
                    classname="deck-hover-popup"
                    properties={hoverData}
                    isGeoFocused={isGeoFocused}
                    handleClose={onCloseRegion}
                    handleNavigation={onNavigateFromRegion}
                    carousel={carousel}
                    onCarouselNext={onCarouselNext}
                    onCarouselPrev={onCarouselPrev}
                />
            )}
        </div>
    );
};
